module.exports = __webpack_public_path__ + "static/enrich-your-life-with-colours-9a437697dc5ad73ee032839629fe7750.png";